import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API_BASE = `${BACKEND_URL}/api`;

// Create axios instance with default config
const apiClient = axios.create({
  baseURL: API_BASE,
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor
apiClient.interceptors.request.use(
  (config) => {
    // Add auth token if available (for future use)
    const token = localStorage.getItem('auth_token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor
apiClient.interceptors.response.use(
  (response) => response.data,
  (error) => {
    if (error.response) {
      // Server responded with error
      console.error('API Error:', error.response.data);
    } else if (error.request) {
      // Request made but no response
      console.error('Network Error:', error.message);
    } else {
      // Something else happened
      console.error('Error:', error.message);
    }
    return Promise.reject(error);
  }
);

// ============================================================================
// IMAGE API
// ============================================================================

export const getImages = async (params = {}) => {
  const response = await apiClient.get('/images', { params });
  return response;
};

export const getImageById = async (imageId) => {
  const response = await apiClient.get(`/images/${imageId}`);
  return response;
};

// Get image without incrementing view count (for subsequent fetches)
export const getImageByIdNoView = async (imageId, alias = '') => {
  // Use the SEO endpoint which doesn't increment views
  const response = await apiClient.get(`/photos/${imageId}-${alias || 'detail'}`);
  return response;
};

export const searchImages = async (query, params = {}) => {
  const response = await apiClient.get('/search', {
    params: { q: query, ...params },
  });
  return response;
};

// ============================================================================
// TAG API
// ============================================================================

export const getAllTags = async () => {
  const response = await apiClient.get('/tags');
  return response.tags;
};

export const getImagesByTagSlug = async (slug, params = {}) => {
  const response = await apiClient.get(`/photos-hd/${slug}`, { params });
  return response;
};

// ============================================================================
// USER/PHOTOGRAPHER API
// ============================================================================

export const getUserById = async (userId) => {
  const response = await apiClient.get(`/users/${userId}`);
  return response;
};

export const getPhotographerByUrl = async (userUrlSlug) => {
  const response = await apiClient.get(`/photos/photographer/${userUrlSlug}`);
  return response;
};

// ============================================================================
// STATS API
// ============================================================================

export const getStats = async () => {
  const response = await apiClient.get('/stats');
  return response;
};

export default apiClient;
